import React from 'react';
import PropTypes from 'prop-types';
import { alpha, useTheme } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import { getCherrySoftwareIcon } from '../cherrySoftwareIcons';

const IconBadge = ({
  icon,
  size = 52,
  color = 'primary',
  variant = 'soft',
  rounded = '18px',
}) => {
  const theme = useTheme();
  const Icon = typeof icon === 'string' ? getCherrySoftwareIcon(icon) : icon;
  const main = theme.palette[color]?.main || theme.palette.primary.main;
  const dark = theme.palette[color]?.dark || theme.palette.primary.dark;

  const softStyles = {
    background: alpha(main, 0.1),
    color: main,
    border: `1px solid ${alpha(main, 0.16)}`,
  };

  const gradientStyles = {
    background: `linear-gradient(135deg, ${main} 0%, ${dark} 100%)`,
    color: theme.palette.common.white,
    boxShadow: `0 12px 28px ${alpha(main, 0.28)}`,
    border: 'none',
  };

  const styles = variant === 'gradient' ? gradientStyles : softStyles;

  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: rounded,
        display: 'grid',
        placeItems: 'center',
        flexShrink: 0,
        ...styles,
        '& svg': { fontSize: Math.round(size * 0.48) },
      }}
    >
      <Icon />
    </Box>
  );
};

IconBadge.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]).isRequired,
  size: PropTypes.number,
  color: PropTypes.string,
  variant: PropTypes.oneOf(['soft', 'gradient']),
  rounded: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default IconBadge;
